// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__g0Tq2","checkbox_checkmark":"Checkbox_checkbox_checkmark__K4RQ5","checkbox_text":"Checkbox_checkbox_text__GTP65"};